import { render } from "./BannersList.vue?vue&type=template&id=485eafcc&scoped=true"
import script from "./BannersList.vue?vue&type=script&lang=js"
export * from "./BannersList.vue?vue&type=script&lang=js"

import "./BannersList.vue?vue&type=style&index=0&id=485eafcc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-485eafcc"]])

export default __exports__